
import ListComponent from "../../../components/dashboard/Index.vue";

export default {
  components: {
    ListComponent
  }
}
